/* eslint-disable */
import React, { useEffect, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import Select from "react-select"; // Ensure react-select is installed
import {
  IS_QUALIFICATION_TYPE_CHANGED_BY_DROPDOWN,
  SET_SELECTED_QUALIFICATION_TYPE,
} from "../../common/constants/ActionTypes";
import {
  getAllQualificationTypes,
  getPublicationTypeData,
  getQualificationNamesOfAType,
} from "../actions/profileAction";
import qualificationinformation from "../labels/qualification_information_en.json";
import qualificationinformation_hindi from "../labels/qualification_information_hin.json";
import numberformat from "../labels/serial_nos_en.json";


const QualificationTypeDropdown = () => {
  const inputRef = useRef();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllQualificationTypes());
    inputRef.current.focus();
  }, []);

  const { qualificationTypes, qualificationtypecode } = useSelector(
    (state) => state.profile,
    shallowEqual
  );

  const onQualificationTypeChange = (e) => {
    let qualificationSelectedTypeCode = e.target.value;
    /** This action is to be dispatched conditionally as a few Qualification Types
     *  don't have the Qualification Name dropdown. */
    try {
      dispatch(getQualificationNamesOfAType(qualificationSelectedTypeCode));

      dispatch({
        type: IS_QUALIFICATION_TYPE_CHANGED_BY_DROPDOWN,
        payload: true,
      });

      dispatch({
        type: SET_SELECTED_QUALIFICATION_TYPE,
        payload: qualificationSelectedTypeCode,
      });
      if (qualificationSelectedTypeCode === "Pb") {
        dispatch(getPublicationTypeData(qualificationSelectedTypeCode));
      }
    } catch (error) {
      throw new Error(error.message);
    }
  };


  return (
    <div className="col-md-4 mb-3 mt-3 responsive-input-qualification-type">
      <label className="float-start mb-0 font-weight">
        {numberformat["4.1"]}&nbsp;{qualificationinformation.QUALIFICATION_TYPE}{" "}
        {qualificationinformation_hindi.QUALIFICATION_TYPE_hin}
        <span className="redColor">*</span>{" "}
      </label>
      <br />
      {/* <select
        className="form-select bg-color"
        name="qualificationtype"
        value={qualificationtypecode}
        onInput={onQualificationTypeChange}
        ref={inputRef}
        disabled={false}
      >
        <option key={0} value="Select">
          {qualificationinformation.Select_Qulification_Type}
        </option>
        {qualificationTypes
          .sort((type1, type2) => {
            return type1.sort_order - type2.sort_order;
          })
          .map((qualificationType, i) => {
            return (
              <option key={i} value={qualificationType.qualificationtypecode}>
                {qualificationType.qualificationtypename}
              </option>
            );
          })}
      </select> */}

      <Select
        className="w-100"
        name="qualificationtype"
        value={
          qualificationTypes.find((type) => type.qualificationtypecode === qualificationtypecode) || null
        }
        getOptionValue={(option) => option.qualificationtypecode}
        getOptionLabel={(option) => option.qualificationtypename}
        onChange={(selectedOption) => {
          onQualificationTypeChange({
            target: { value: selectedOption.qualificationtypecode },
          });
        }}
        isSearchable={true} // Enables search functionality
        options={qualificationTypes.sort((a, b) => a.sort_order - b.sort_order)}
        isDisabled={false} // Modify as needed
        ref={inputRef}
      />
    </div>
  );
};

export default QualificationTypeDropdown;
